import React, { ComponentProps, FunctionComponent } from "react";

const ClockOutlineIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22 22",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9996 20.1424C5.95034 20.1424 1.85851 16.049 1.85851 11.0013C1.85851 5.95211 5.95034 1.85851 10.9996 1.85851C16.0488 1.85851 20.1415 5.95189 20.1415 11.0013C20.1415 16.0488 16.049 20.1424 10.9996 20.1424ZM10.9996 0C17.0742 0 22 4.9251 22 11.0013C22 17.076 17.074 22 10.9996 22C4.92488 22 0 17.0758 0 11.0013C0 4.9251 4.9251 0 10.9996 0ZM10.9996 3.71813C10.486 3.71813 10.0707 4.13434 10.0707 4.64874V10.9866V10.9918C10.0689 11.2333 10.1576 11.4749 10.3418 11.6591L14.8331 16.1489C15.0147 16.3322 15.2511 16.4217 15.49 16.4217C15.7272 16.4217 15.9653 16.3322 16.1469 16.1489C16.5093 15.7865 16.5093 15.1983 16.1469 14.836L11.9292 10.6182V4.64877C11.9292 4.13437 11.514 3.71813 10.9996 3.71813Z",
    })
  );
};

const ForwardRef = React.forwardRef(ClockOutlineIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
